var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.668 21.6663H3.33464C2.62739 21.6663 1.94911 21.3854 1.44902 20.8853C0.94892 20.3852 0.667969 19.7069 0.667969 18.9997V2.88368C0.697879 2.19673 0.991981 1.54789 1.48887 1.07261C1.98576 0.597332 2.64704 0.332358 3.33464 0.333009H24.668C25.3752 0.333009 26.0535 0.61396 26.5536 1.11406C27.0537 1.61415 27.3346 2.29243 27.3346 2.99968V18.9997C27.3346 19.7069 27.0537 20.3852 26.5536 20.8853C26.0535 21.3854 25.3752 21.6663 24.668 21.6663ZM3.33464 5.49034V18.9997H24.668V5.49034L14.0013 12.5997L3.33464 5.49034ZM4.4013 2.99968L14.0013 9.39968L23.6013 2.99968H4.4013Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.75e070befa2b4972a00dec22a0d8461b.svg";
export { ForwardRef as ReactComponent };